<ion-content>
	<ion-refresher
				   slot="fixed"
				   (ionRefresh)="refresh($event)"
				   [attr.disabled]="requesting">
		<ion-refresher-content></ion-refresher-content>
	</ion-refresher>
	<ion-progress-bar *ngIf="requesting" type="indeterminate"></ion-progress-bar>
	<div
		 fxFill
		 [class.disabled]="requesting"
		 class="container"
		 fxLayout="column"
		 fxLayoutAlign="space-between stretch">
		<div class="info ion-padding" fxFlex="none" fxLayout="column">
			<small class="text-muted ion-margin-top">{{ 'Today' | translate }}</small>
			<div fxLayout="row" fxLayoutAlign="space-between end">
				<div class="date-time" *ngIf="dateTime">
					<div>{{ dateTime | datetime: 'ddd, MMM DD' }}</div>
				</div>
				<ng-container *ngIf="condition">
					<div class="condition" fxLayout="end center">
						<div *ngIf="condition.code" class="weather-icon-{{ condition.code }}"></div>
						<span>{{ condition.temperature | temperature: 'unit' }}</span>
					</div>
				</ng-container>
			</div>
		</div>
		<div
			 fxFlex="none"
			 class="company"
			 fxLayoutAlign="start center"
			 fxLayoutGap="10px">

			<ng-container *ngIf="companies?.length; else noCompanies">
				<ion-select
							#companiesSelector
							[disabled]="shiftButtonCurrentStatus === shiftButtonStatus.PLAY"
							class="ion-hide"
							interface="action-sheet"
							(ionChange)="companiesSelected(companiesSelector.value)"
							[cancelText]="'Cancel' | translate"
							[okText]="'OK' | translate">
					<ng-container *ngFor="let company of companies">
						<ion-select-option [value]="company">
							{{ company.name }}
						</ion-select-option>
					</ng-container>
				</ion-select>
				<ng-container *ngIf="company; else noCompany">
					<h1 (click)="companies?.length > 1 && companiesSelector?.open()">
						{{ company.name }}
					</h1>
				</ng-container>
				<ng-template #noCompany>
					<h1 class="no-company-selected" (click)="companies?.length > 1 && companiesSelector?.open()">
						{{ 'Select a Company' | translate }}
					</h1>
				</ng-template>
				<ion-icon *ngIf="shiftButtonCurrentStatus === shiftButtonStatus.STOP && companies?.length > 1"
						  (click)="companies?.length > 1 && companiesSelector?.open()"
						  fxFlex="none"
						  name="caret-down"></ion-icon>
			</ng-container>
			<ng-template #noCompanies>
				<div
					 (click)="refresh()"
					 [class.disabled]="requesting"
					 fxLayoutAlign="start center">
					<h5 class="ion-text-center">
						{{ 'Pending acceptance or no associated Company.' | translate }}
					</h5>
					<ion-icon size="large" name="refresh-outline"></ion-icon>
				</div>
			</ng-template>
		</div>
		<div class="launch">
			<div class="cell shift">
				<ng-container *ngIf="shiftButtonCurrentStatus === shiftButtonStatus.STOP">
					<div
						 [class.no-company-selected]="!company"
						 class="blue-button"
						 (click)="startShift()">
						<div class="custom-icon start"></div>
					</div>
					<span>{{ 'Start Shift' | translate }}</span>
				</ng-container>
				<ng-container *ngIf="shiftButtonCurrentStatus === shiftButtonStatus.PLAY">
					<div
						 [class.no-company-selected]="!company"
						 class="blue-button play"
						 (click)="endShift()">
						<div class="custom-icon end"></div>
					</div>
					<span>{{ 'End Shift' | translate }}</span>
				</ng-container>
				<ng-container *ngIf="shiftButtonCurrentStatus === shiftButtonStatus.NOT_READY">
					<div class="blue-button not-ready">
						<div class="custom-icon start"></div>
					</div>
					<span>{{ '...' | translate }}</span>
				</ng-container>
			</div>
			<div class="cell" (click)="openMessagesModal()">
				<div class="blue-button">
					<div class="custom-icon messages"></div>
					<div class="messages-unread" *ngIf="unreadMessages">
						{{ unreadMessages }}
					</div>
				</div>
				<span>{{ 'Messages' | translate }}</span>
			</div>
			<div
				 class="cell"
				 [class.no-company-selected]="!company"
				 routerLink="/auth/route/index"
				 routerDirection="forward">
				<div class="blue-button">
					<div class="custom-icon routes"></div>
				</div>
				<span>{{ 'Routes' | translate }}</span>
			</div>
			<div
				 class="cell"
				 [class.no-company-selected]="!company"
				 routerLink="/auth/history/shift/index"
				 routerDirection="forward">
				<div class="blue-button">
					<div class="custom-icon shifts"></div>
				</div>
				<span>{{ 'Shift History' | translate }}</span>
			</div>
			<div
				 class="cell"
				 routerLink="/auth/news-training"
				 routerDirection="forward">
				<div class="blue-button">
					<div class="custom-icon training"></div>
				</div>
				<span>{{ 'News Training' | translate }}</span>
			</div>
			<div class="cell" routerLink="/auth/account" routerDirection="forward">
				<div class="blue-button">
					<div class="custom-icon account"></div>
				</div>
				<span>{{ 'Account' | translate }}</span>
			</div>
		</div>
		<!-- Footer -->
		<div fxFlex="none" class="footer ion-text-center ion-margin-top">
			<small>
				<img class="white" src="/assets/image/yeti_software.png" />
				<img class="dark" src="/assets/image/white_yeti_software.png" />
			</small>
		</div>
	</div>
</ion-content>